import React from "react";

const CreateAccountModal = ({ onClose, onSwitchToSignIn }) => {
  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center px-4 py-6">
      
      <div className="w-full max-w-[900px] bg-[#FAFAF9] rounded-2xl border border-gray-200 shadow-xl flex flex-col lg:flex-row" style={{ maxHeight: "90vh" }}>

        {/* LEFT FORM — flex column so footer sticks to bottom */}
        <div className="flex flex-col flex-1 min-h-0">

          {/* Header */}
          <div className="flex items-center justify-between px-6 py-5 border-b border-gray-200">
            <h2 className="text-xl font-semibold text-gray-900">Create your account</h2>
            <button onClick={onClose} className="text-gray-500 hover:text-gray-700">✕</button>
          </div>

          {/* Scrollable body */}
          <div className="flex-1 overflow-y-auto px-6 py-6 space-y-4">
            <Input label="Full name" placeholder="Fatima Khan" />
            <Input label="Work email" placeholder="finance@company.com" />
            <Input label="Company name" placeholder="Acme Pvt Ltd" />
            <Input label="Password" placeholder="Create a strong password" type="password" />
            <Input label="Referral (optional)" placeholder="Code or partner name" />

            <p className="text-xs text-gray-500">
              By creating an account you agree to our{" "}
              <span className="underline cursor-pointer">Terms</span> and{" "}
              <span className="underline cursor-pointer">Privacy</span>.
            </p>

            <p className="text-sm text-gray-600">
              Already have an account?{" "}
              <button onClick={onSwitchToSignIn} className="text-[#00B39F] font-medium hover:underline">
                Sign in
              </button>
            </p>
          </div>

          {/* Footer — always visible */}
          <div className="flex justify-end gap-3 px-6 py-5 border-t border-gray-200">
            <button onClick={onClose} className="h-10 px-4 rounded-lg border border-gray-300 text-sm">
              Back
            </button>
            <button className="h-10 px-5 rounded-lg bg-[#00B39F] text-white text-sm font-medium">
              Create account
            </button>
          </div>
        </div>

        {/* RIGHT PANEL */}
        <div className="hidden lg:block w-[320px] bg-[#D7F4F0] rounded-tr-2xl rounded-br-2xl p-6 flex-shrink-0">
          <h3 className="text-sm font-semibold text-gray-900 mb-4">Why create an account?</h3>
          <div className="space-y-3">
            <InfoItem label="Advance estimates" value="Instant" />
            <InfoItem label="Funds speed" value="24–48 hrs" />
            <InfoItem label="Support hours" value="Mon–Fri" />
          </div>
        </div>

      </div>
    </div>
  );
};

const Input = ({ label, placeholder, type = "text" }) => (
  <div>
    <label className="block text-sm text-gray-600 mb-1">{label}</label>
    <input
      type={type}
      placeholder={placeholder}
      className="w-full h-11 rounded-lg border border-gray-300 px-3 text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
    />
  </div>
);

const InfoItem = ({ label, value }) => (
  <div className="bg-white rounded-lg px-4 py-3 flex justify-between items-center">
    <span className="text-sm text-gray-500">{label}</span>
    <span className="text-sm font-semibold text-gray-900">{value}</span>
  </div>
);

export default CreateAccountModal;